// File → wp-content/themes/donne-coop/src/js/custom-javascript.js

import initCDCGalleryGlightbox from './modules/gallery-glightbox-init';


/**
 * Calcola l'altezza della bottom bar e la imposta come variabile CSS per non sovrapporre i contenuti
 * Usare var(--bottom-bar-height) in CSS
 * Filtro php 'body_class' aggiunge la classe '.has-bottom-bar' al body se la bottom bar è presente
 * Es. .has-bottom-bar { padding-bottom: var(--bottom-bar-height); }
 * 
 * @return {void}
 */
function setBottomBarHeight() {
    const bottomBar = document.querySelector('.bottom-bar');
    if (bottomBar) {
        const height = bottomBar.offsetHeight;
        document.documentElement.style.setProperty('--bottom-bar-height', `${height}px`);
    }
}

// Quando il DOM è completamente caricato...
document.addEventListener('DOMContentLoaded', function () {

    // Imposta l'altezza iniziale della barra in basso se presente
    setBottomBarHeight();


    // Inizializza GLightbox per le gallerie immagini
    initCDCGalleryGlightbox('.glightbox-item');

});